import { Component, EventEmitter, input, Output } from "@angular/core";
import { EvDialogModule } from "ev-dialog";

@Component({
    selector: "favorite-list-confirm-close",
    templateUrl: "./favorite-list-confirm-close.component.html",
    styleUrl: "./favorite-list-confirm-close.component.scss",
    imports: [EvDialogModule],
})
export class FavoriteListConfirmCloseComponent {
    show = input<boolean>(false);
    @Output() onClose: EventEmitter<void> = new EventEmitter();
    @Output() onConfirm: EventEmitter<void> = new EventEmitter();

    public closeDialog() {
        this.onClose.emit();
    }

    public confirmDialog() {
        this.onConfirm.emit();
    }
}
